import { fields } from "@/questionaryInfoConfig";
import config from "@/config";

export const getQuestionaryInfoFields = () => {
  return fields.filter(i => (config.questionaryHiddenField as string[]).indexOf(i.name) === -1);
};
